export const THANK_YOU_PAGE_PATH = '/thank-you';

/** Query flag when PaymentIntent is still processing (no order yet). */
export const THANK_YOU_PAYMENT_STATUS_PARAM = 'payment_status';
export const THANK_YOU_PAYMENT_STATUS_PROCESSING = 'processing';

export const buildThankYouProcessingPath = (): string => {
  const params = new URLSearchParams({
    [THANK_YOU_PAYMENT_STATUS_PARAM]: THANK_YOU_PAYMENT_STATUS_PROCESSING,
  }).toString();
  return `${THANK_YOU_PAGE_PATH}/?${params}`;
};
